import React, { useContext } from "react";
import { IColuna } from "app/types/IColuna";
import { PaginaPesquisaProdutoContext } from "../../pagina-pesquisa-produto/PaginaPesquisaProduto";
import { COLUNAS_ALINHADAS_DIREITA_PESQUISA_PRODUTO, obterOcultarColunasBasePesquisaProduto, ordenarColunas, traduzirOrdenarNomeColunaPesquisaProduto } from "../TraduzirOrdenarNomeColunaPesquisaProduto";
const estiloTableHead =
  require("./HeadersPesquisaProdutos.module.scss").default;
import clsx from "clsx";

export const HeadersPesquisaProdutos = () => {
  const contexto = useContext(PaginaPesquisaProdutoContext)

  const ocultarColunas: { [key: string]: boolean } = {
    ...obterOcultarColunasBasePesquisaProduto(contexto),
    Quantidade: true, // Cabeçalho da coluna Quantidade removido (itemPesquisaProduto_ColunaQuant)
    Ações: true,
  };
  const colunasOcultas = (nomeColuna: string) =>
    ocultarColunas[nomeColuna] == undefined
      ? false
      : ocultarColunas[nomeColuna];

  const exibirColuna = (coluna: IColuna) => contexto.colunas.find((c) => c.Nome == coluna.Nome && !colunasOcultas(traduzirOrdenarNomeColunaPesquisaProduto({ nomeColuna: c.Nome, nomeGrid: "PESQUISAR_PRODUTOS_ORCAMENTO" })))?.Selecionada == true;

  return (
    <>
      <tr
      id="HeadersPesquisaProduto_linha"
      >
      <th></th>
        {/* 491123 — cabeçalho vazio correspondente à coluna de seleção rápida (ícone +/lixeira +
            stepper de quantidade) inserida em ItemPesquisaProduto.tsx, logo após AgregadoSugerido */}
        {contexto.chamadoParaInserirProdutoNoOrcamento && !contexto.pesquisandoApenasParaFiltroProdutosLupa && (
          <th id="HeaderPesquisaProduto_Coluna_SelecaoRapida"></th>
        )}
        {ordenarColunas(contexto.colunas)
        ?.filter(exibirColuna)
        .map(
          (coluna, key) =>
            coluna.Selecionada && (
              <th
                key={key}
                id={`HeaderPesquisaProduto_Coluna_${coluna.Nome.replace(/\s+/g, '')}`}
                className={clsx(
                  coluna.Classes,
                  COLUNAS_ALINHADAS_DIREITA_PESQUISA_PRODUTO.includes(coluna.Nome)
                    ? estiloTableHead.colunaAlinhadaDireita
                    : estiloTableHead.colunaAlinhadaEsquerda)}
              >
                {traduzirOrdenarNomeColunaPesquisaProduto({
                  nomeColuna: coluna.Nome,
                  nomeGrid: "PESQUISAR_PRODUTOS_ORCAMENTO",
                })}
                {coluna.Selecionada}
              </th>
            )
        )}
        <th id={`HeaderPesquisaProduto_Coluna_Vazia`}></th>
      </tr>
    </>
  );
};
